import "../../css/widgets/widgets.css";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { PieChart, Series, Size, Connector, Legend, Animation } from 'devextreme-react/pie-chart';
import { seconds2HMS } from "../utils/utils";
function IncomingGroupCalls(props) {

    const { t } = useTranslation();
    const [calls, setCalls] = useState([]);
    useEffect(() => {
        setCalls([{
            "state": t("answered"),
            "amount": props.group.answeredCalls
        }, {
            "state": t("missed"),
            "amount": props.group.missedCalls
        },
        ]);
        return () => {
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customizePoint = (e) => {
        if (e.argument === t("answered")) {
            return {
                color: "#50cd89"
            }
        }
        if (e.argument === t("missed")) {
            return {
                color: "#f1416c"
            }
        }
    }


    return (
        <div className={"card card-flush overflow-hidden"} >
            <div className="card-header ">
                <h3 className="card-title align-items-start flex-column text-primary">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("phone-arrow-down-left")} /> {t("incomingcalls")}</span>
                </h3>
                <div className="card-toolbar">
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <Row>
                    <Col >
                        <div className="fs-2hx fw-bold text-gray-800">{props.group.incomingCalls}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("total")}</div>
                    </Col>
                    <Col >
                        <div className="fs-2hx fw-bold text-success">{props.group.answeredCalls}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("attended")}</div>
                    </Col>
                    <Col >
                        <div className="fs-2hx fw-bold text-danger">{props.group.missedCalls}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("missed")}</div>
                    </Col>
                    <Col >
                        <div className="fs-2hx fw-bold text-gray-800">{seconds2HMS(props.group.averageWaitingTime)}</div>
                        <div className="fs-5 fw-semibold text-gray-400 ">{t("averagewaitingtime")}</div>
                    </Col>
                    <Col>
                        <PieChart

                            id="incommingcalls"
                            dataSource={calls}
                            type="doughnut"
                            resolveLabelOverlapping="shift"
                            sizeGroup="piesGroup"
                            innerRadius={0.8}
                            customizePoint={customizePoint}
                            centerRender={(pie) => {
                                return (
                                    <svg>
                                        <text textAnchor="middle" x="40" y="40" style={{ fontSize: 18, fill: localStorage.getItem("faTheme") === "light" ? '#3f4254' : "#cdcdde" }}>
                                            <tspan x="70" style={{ fontWeight: 600, fontSize: "20px" }}>{props.group.answeredCallsPercentage}%</tspan>
                                        </text>
                                    </svg>
                                );
                            }}
                        >
                            <Size
                                height={70}
                                width={90}
                            />
                            <Series
                                argumentField="state"
                                valueField="amount"
                            >
                                <Connector visible={true}></Connector>
                            </Series>
                            <Legend visible={false}></Legend>
                            <Animation enabled={true}></Animation>
                        </PieChart>
                    </Col>
                </Row>
            </div>
        </div>

    )
}
export default IncomingGroupCalls;